import * as React from 'react'

import { StoreButtonImage } from './StoreButtonImage.styles'

const APP_STORE_URL = 'https://apps.apple.com/us/app/wonderschool/id1455389693'
const APP_STORE_IMAGE =
  'https://ucarecdn.com/c56af23b-5944-4005-b95f-ea0c1b798d01/downloadontheappstoreapple2x.png'

export default function AppStoreButton() {
  return (
    <a href={APP_STORE_URL}>
      <StoreButtonImage alt="Download on the App Store" src={APP_STORE_IMAGE} />
    </a>
  )
}
